import { render, staticRenderFns } from "./StudentUserInformation.vue?vue&type=template&id=4489726e&scoped=true"
import script from "./StudentUserInformation.vue?vue&type=script&lang=js"
export * from "./StudentUserInformation.vue?vue&type=script&lang=js"
import style0 from "./StudentUserInformation.vue?vue&type=style&index=0&id=4489726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489726e",
  null
  
)

export default component.exports